export interface ShareContactType {
  id: number;
  folder_id?: number;
  first_name: string;
  last_name: string | null;
  profile_image: string | null;
  email: string | null;
  role_name?: string | null;
  type: string;
  by: string;
  can_edit: 1 | 0;
  can_view: 1 | 0;
}

export const mapShareContactType = (data: any): ShareContactType => {
  if (!data) {
    throw new Error("Invalid Data");
  }

  const res: ShareContactType = {
    id: data.id,
    folder_id: data.folder_id !== null ? data.folder_id : 0,
    first_name: data.first_name,
    last_name: data.last_name ?? null,
    profile_image: data.profile_image ?? null,
    email: data.email ?? null,
    role_name: data.role_name ?? null,
    type: data.type ? data.type : data.main_type,
    by: data.by,
    can_edit: data.can_edit,
    can_view: data.can_view,
  };

  return res;
};

export const mapShareContactTypes = (data: any[]): ShareContactType[] => {
  if (!Array.isArray(data)) {
    throw new Error("Invalid Data");
  }

  return data.map(mapShareContactType);
};
